import * as angular from "angular";
import {IController, ITimeoutService} from "angular";
import * as _ from "lodash";
import {MapsCommonService} from "../../services/mapsCommon.service";

export class OmsOrderMapComponent implements IController {
  fulfillmentLines: any;

  private mapTypeIds: any = {
    roadmap: 'ROADMAP',
    satellite: 'SATELLITE'
  };
  private filters: any = {
    traffic: false,
    addresses: true,
    satellite: false
  };
  private map: any;
  private mapRef: any;
  private isReady: boolean;
  private fulfillmentLinesLayerRef: any;

  constructor(private mapsCommonService: MapsCommonService, private $timeout: ITimeoutService) {
  }

  $onInit() {
    this.map = {
      isReady: false,
      center: this.mapsCommonService.getSiteLocation(),
      zoom: 12,
      events: {
        idle: (map) => {
          if (!this.isReady) {
            this.mapRef = map;
            this.isReady = true;
            google.maps.event.trigger(map, 'resize');
            this.centerMap();
            // resizeService.resize();
          }
        },
      },
      fulfillmentLinesLayerEnabled: true,
      fulfillmentLinesLayerCallback: (layer) => {
        this.fulfillmentLinesLayerRef = layer;

        if (this.fulfillmentLines?.length) {
          this._setFulfillmentLinesTasksMarkersOnLayer(this.fulfillmentLines);
        }

      },
      options: {
        styles: this.mapsCommonService.getDefaultStyle(),
        mapTypeControl: false,
        scaleControl: true,
        mapTypeId: google.maps.MapTypeId[this.mapTypeIds.roadmap]
      },
      bounds: {}
    };
    // this.centerMap();
  }

  $onChanges(changes) {
    if (changes.fulfillmentLines && !changes.fulfillmentLines.isFirstChange()) {
      this.centerMap();
      this._removeFeaturesFromLayer();
      this._setFulfillmentLinesTasksMarkersOnLayer(this.fulfillmentLines);
    }
  }

  onMapTypeChange(isSatelliteEnabled) {
    this.map.options.mapTypeId = google.maps.MapTypeId[isSatelliteEnabled ? this.mapTypeIds.satellite : this.mapTypeIds.roadmap];
  }

  centerMap() {
    let tasks = []
    _.forEach(this.fulfillmentLines, item => {
      if (item.pickupTask) {
        tasks.push(item.pickupTask);
      }
      if (item.destinationTask) {
        tasks.push(item.destinationTask);
      }
    });
    tasks = _.filter(tasks, (m) => {
      return _.get(m, 'location.address.location');
    })
    if (tasks.length) {
      this.mapsCommonService.centerMapByBounds(this.map, tasks);
    }

    if (tasks.length === 1) {
      this.$timeout(0).then(() => {
        this.mapRef.setZoom(18);
      });
    }
  }

  private _setFulfillmentLinesTasksMarkersOnLayer(fulfillmentLines) {
    if (this.fulfillmentLinesLayerRef) {
      let geoJson = this.mapsCommonService.convertFulfillmentLinesTasksToGeoJson(fulfillmentLines);

      // Add fulfillment lines tasks to layer
      this.fulfillmentLinesLayerRef.addGeoJson(geoJson);

      // Set feature style by its properties
      this.fulfillmentLinesLayerRef.setStyle((feature) => {
        return this._taskFeatureStyle(feature);
      });

    }
  }

  private _taskFeatureStyle(feature) {
    const purpose = feature.getProperty('purpose');

    return {
      visible: true,
      icon: this.mapsCommonService.getTaskMarkerIconNew(purpose, undefined, false)
    }
  }

  private _removeFeaturesFromLayer() {
    this.fulfillmentLinesLayerRef?.forEach((feature) => {
      this.fulfillmentLinesLayerRef.remove(feature);
    });
  }

}

angular
  .module('bringoz.admin.map')
  .component('omsOrderMap', {
    bindings: {
      fulfillmentLines: '<',
      addMarkerPurpose: '<',
      onPickupLocationSelect: '&?',
      onDestinationLocationSelect: '&?'
    },
    template: require('./oms-order-map.html').default,
    controller: OmsOrderMapComponent
  });
